import styles from "../../ModalCriarRota/ModalCriarRota.module.css";
import { Field, Form, Formik } from "formik";
import Button from "../../../../../components/components-ui/Button/Button";
import { Col, Grid } from "../../../../../components/Grid";
import {
  customStyles,
  SelectSearch,
} from "../../../../../components/components-ui/SelectSearch/SelectSearch";
import Select from "react-select";
import api from "../../../../../services/Api";
import { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Loading from "../../../../../components/components-ui/Loading/Loading";
import Api from "../../../../../services/Api";
import CustomConfirmAlert from "../../../../../components/components-ui/CustomConfirmAlert/CustomConfirmAlert";

const API_MARCA = "/freguesia/listalocalfreguesia?nome_local=";
const API_NAO_TEM_OLEO = "/coleta/naotemoleo";

function ModalNaoTemOleo({
  idColeta,
  closeModal,
  data,
  responsavel,
  userId,
  nomeLocal,
  idLocal,
  closeModalAdicionarColeta,
}) {
  const [locais, setLocais] = useState([]);
  const [inputMarca, setInputMarca] = useState("aa");
  const [loadingInput, setLoadingInput] = useState(false);
  const observacaoRef = useRef(null);

  const getMarca = async (input) => {
    setLoadingInput(true);
    await api
      .get(API_MARCA + input)
      .then((res) => {
        setLocais(res.data.data);
        setLoadingInput(false);
      })
      .catch((error) => {
        setLoadingInput(false);
        console.log(error);
      });
  };

  useEffect(() => {
    if (observacaoRef.current) {
      observacaoRef.current.focus();
    }
  }, []);

  //Buscar locais ao digitar
  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputMarca.length) {
        getMarca(inputMarca);
      } else {
        setLocais([]);
      }
    }, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [inputMarca]);

  const confirmarNaoTemOleo = (values) => {
    CustomConfirmAlert({
      subtitle: `Confima o lançamento de 'NÃO TEM ÓLEO' para a coleta nº ${idColeta}?`,
      labelBtnConfirmar: "Confirmar",
      onConfirm: async () => {
        const promise = api.post(API_NAO_TEM_OLEO, {
          idColeta,
          observacao: values?.observacao,
        });

        toast.promise(promise, {
          pending: "Carregando...",
          success: {
            render({ data }) {
              const res = data.data;
              if (res.error === 0) {
                return res.msg || "Não Tem Óleo criado com sucesso!";
              }
              throw new Error(res.msg || `Erro: ${res.error}`);
            },
          },
          error: {
            render({ data }) {
              return data?.message || "Erro ao criar coleta não tem óleo rota";
            },
          },
        });

        try {
          const response = await promise;
          const res = response.data;
          if (res.error === 0) {
            closeModal();
            closeModalAdicionarColeta();
          }
        } catch (error) {
          console.error("Erro ao cancelar rota: ", error);
        }
      },
    });
  };

  const validationSchema = Yup.object().shape({
    local: Yup.object()
      .shape({
        label: Yup.string().required(),
        value: Yup.number().required(),
      })
      .nullable()
      .required("Selecione o local"),
    responsavel: Yup.string().nullable(),
    observacao: Yup.string()
      .min(5, "Digite no mínimo 5 caracteres")
      .required("Informe um motivo!"),
  });

  return (
    <div className={styles.modal_container}>
      <h2 style={{ textAlign: "center" }}>Não Tem Óleo</h2>
      <Formik
        initialValues={{
          data: data,
          responsavel: userId,
          local: {
            value: idLocal,
            label: `(${idLocal}) - ${nomeLocal}`,
          },
          observacao: "",
        }}
        validationSchema={validationSchema}
        onSubmit={(values) => confirmarNaoTemOleo(values)}
      >
        {({
          errors,
          touched,
          values,
          isSubmitting,
          isValid,
          setFieldValue,
        }) => (
          <Form>
            <div>
              <Grid>
                <Col size={2}>
                  <label>Data</label>
                  <Field type="date" name="data" disabled />
                  {errors.data && touched.data ? (
                    <span className={styles.alertError}>{errors.data}</span>
                  ) : null}
                </Col>
                <Col size={3}>
                  <label> Responsável </label>
                  <Field
                    component={SelectSearch}
                    disabled
                    name="responsavel"
                    options={responsavel.map((values) => ({
                      value: values?.id_usuario,
                      label: values?.nome_usuario,
                    }))}
                  />
                </Col>
              </Grid>
              <Grid>
                <Col size={12}>
                  <label>Local</label>
                  <Field name="local">
                    {({ ...field }) => (
                      <Select
                        {...field}
                        value={values.local}
                        options={locais.map((values) => ({
                          label: values?.NomeLocal,
                          value: values?.IdLocal,
                        }))}
                        styles={customStyles}
                        placeholder="Digite para buscar..."
                        noOptionsMessage={() =>
                          loadingInput
                            ? "Carregando..."
                            : inputMarca.length
                            ? "Nenhuma opção encontrada"
                            : "Digite parte do nome"
                        }
                        onChange={(selectedOption) =>
                          setFieldValue("local", selectedOption)
                        }
                        onInputChange={(e) => setInputMarca(e)}
                        isClearable
                        isDisabled
                        menuPortalTarget={document.body}
                      />
                    )}
                  </Field>
                  {errors.local && touched.local ? (
                    <span className={styles.alertError}>{errors.local}</span>
                  ) : null}
                </Col>
              </Grid>
              <Grid>
                <Col size={12}>
                  <label>Observação</label>
                  <Field
                    type="textarea"
                    name="observacao"
                    style={{ height: "50px" }}
                  >
                    {({ field }) => (
                      <textarea
                        {...field}
                        ref={observacaoRef}
                        rows={3}
                        placeholder="Digite o motivo..."
                      />
                    )}
                  </Field>
                  {errors.observacao && touched.observacao ? (
                    <span className={styles.alertError}>
                      {errors.observacao}
                    </span>
                  ) : null}
                </Col>
              </Grid>
              <div className={styles.buttons_container}>
                <Button
                  title="Salvar"
                  type="submit"
                  //   disabled={isSubmitting}
                  className={styles.button_sm}
                />
                <Button
                  title="Fechar"
                  type="button"
                  //   disabled={isSubmitting}
                  onClick={() => closeModal()}
                  color={"secondary"}
                  className={styles.button_sm}
                />
              </div>
              {/* {isSubmitting && (
                <div className={styles.loading_container}>
                  <Loading display={isSubmitting ? "block" : "none"} />
                </div>
              )} */}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default ModalNaoTemOleo;
